import React from 'react';
import $ from 'jquery';
import Plotly from 'plotly.js/dist/plotly.min.js';
import {GetParams, MWBaseURL} from './../Utilities.js'
import {createApiClient} from "../api/ApiClient";

class AnalyticsGraph extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			date: null,
			start: null,
			end: null,
			firm: null,
			acct: null,
			sybl: null,

			startTS: null,
			endTS: null,

			needToUpdate: false,
			updateCount: 0,

			graphIsLoading: props.graphIsLoading
		};

		this.timeseries = []

		this.graphLayout = {
			height: props.height,
			showlegend: false,
			xaxis: {
				rangemode: "tozero"
			},
			yaxis: {
				title: "Net PNL",
				fixedrange: true,
				tickformat: '$,~s'
			},
			legend: {"orientation": "h"},
			margin: {
				b: 50,
				t: 0,
				pad: 0
			}
		}

		this.graphConfig = {
			displaylogo: false,
			scrollZoom: true,
			responsive: true,
			displayModeBar: false
		}
		this.controller = new AbortController()
	}

	static getDerivedStateFromProps(props, state) {
		if((state.date && props.date && state.date !== props.date)
			|| state.firm !== props.firm || state.acct !== props.acct || (state.sybl && props.sybl && state.sybl.toString() !== props.sybl.toString())
			|| state.updateCount !== props.updateCount){
			return {...props, needToUpdate: true}
		}
		return {...props};
	}

	componentDidUpdate(props, state){
		if(this.state.needToUpdate){
			let self = this
			this.setState({needToUpdate: false}, function(){
				self.loadGraph()
			})
		}
	}

	componentDidMount() {
		this.loadGraph()
	}

	componentWillUnmount(){
		this.setState({graphIsLoading: false})
		this.controller.abort();
	}

	resizeGraph = () => {

		/*Plotly.relayout( 'graph', {//for switching between days
			'xaxis.autorange': true,
			'yaxis.autorange': true,
			'relayedout': true
		});*/

		let self = this
		let resizeCoord = {
			'relayedout': true
		}
		if(this.state.start && this.state.start >= self.state.startTS){
			resizeCoord["xaxis.range[0]"] = this.state.start
		}else{
			resizeCoord["xaxis.range[0]"] = self.state.startTS
		}
		if(this.state.end && this.state.end <= self.state.endTS){
			resizeCoord["xaxis.range[1]"] = this.state.end
		}else{
			resizeCoord["xaxis.range[1]"] = self.state.endTS
		}
		
		//fix x axis
		let obj = {}
		if(this.state.start && this.state.start < self.state.startTS){
			obj["selectedx0"] = null
		}
		if(this.state.end && this.state.end > self.state.endTS){
			obj["selectedx1"] = null
		}
		if("selectedx0" in obj || "selectedx1" in obj){
			self.state.refilter(obj)
		}

		if(!this.state.start && !this.state.end){
			resizeCoord["xaxis.autorange"] = true
		}

		let relevantData = this.timeseries;

		if(this.state.start){
			relevantData = relevantData.filter(function(obj){
				return (obj.timestamp > self.state.start)
			})
			let tempIdx = this.timeseries.slice().reverse().findIndex(x => x.timestamp < self.state.start)
			let prevIdx = this.timeseries.length - tempIdx - 1
			if(tempIdx !== -1 && prevIdx >= 0){
				relevantData.unshift(this.timeseries[prevIdx])
			}
		}
		if(this.state.end){
			relevantData = relevantData.filter(function(obj){
				return (obj.timestamp < self.state.end)
			})
			let nextIdx = this.timeseries.findIndex(x => x.timestamp > self.state.end)
			if(nextIdx !== -1){
				relevantData.push(this.timeseries[nextIdx])
			}
		}

		if(relevantData.length <= 0){
			console.log("No data for resizing?")
			return
		}
		if("pnl" in relevantData[0]){
			let pnlArr = relevantData.map(x => x.pnl)
			let minpnl = Math.min(...pnlArr)
			let maxpnl = Math.max(...pnlArr)
			resizeCoord["yaxis.range[0]"] = minpnl - (maxpnl - minpnl) * 0.05
			resizeCoord["yaxis.range[1]"] = maxpnl + (maxpnl - minpnl) * 0.05
		}
		if("position" in relevantData[0]){
			let posArr = relevantData.map(x => x.position)
			let minpos = Math.min(...posArr)
			let maxpos = Math.max(...posArr)
			resizeCoord["yaxis2.range[0]"] = minpos - (maxpos - minpos) * 0.05
			resizeCoord["yaxis2.range[1]"] = maxpos + (maxpos - minpos) * 0.05
		}
		if("market_price" in relevantData[0]){
			let priceArr = relevantData.map(x => x.market_price)
			let minprice = Math.min(...priceArr)
			let maxprice = Math.max(...priceArr)
			resizeCoord["yaxis3.range[0]"] = minprice - (maxprice - minprice) * 0.05
			resizeCoord["yaxis3.range[1]"] = maxprice + (maxprice - minprice) * 0.05
		}
		Plotly.relayout(document.getElementById('graph'), resizeCoord)
	}

	loadGraph = () => {
		/*Plotly.extendTraces('graph', {
			y: [[Math.random()]],
			x: [[cnt]]
		}, [0])*/

		let self = this;

		this.controller.abort();
		this.controller = new AbortController()

		self.setState({ graphIsLoading: true })

		const apiClient = createApiClient();
		apiClient.get(MWBaseURL()+'analysis_timeseries?'+GetParams(this.state), {signal: this.controller.signal})
		.then(data => {
			/*if(data.length <= 0){
				console.log("No timeseries data")
				return;
			}*/

			if($('#graph').length === 0){//this should be debugged as this error should never actually appear
				console.log("Graph does not exist this component should not exist")
				return;
			}

			self.timeseries = data

			self.setState({graphIsLoading: false}, function(){
				if(data.length > 1){
					self.setState({
						startTS: data[0].timestamp,
						endTS: data[data.length - 1].timestamp
					}, function(){
						self.state.refilter({
							tsTimeS: data[0].timestamp,
							tsTimeE: data[data.length - 1].timestamp
						})
					})
				}
			})

			let graphLines = [{
				name: "Net P&L",
				hovertemplate: '%{y:$,.0f}',
				y: data.map(x => x.pnl),
				x: data.map(x => x.timestamp),
				line: {
					color: (data.length > 0 && data[data.length-1].pnl > 0 ? "#228B22" : "#8B0000")
				}
			}]

			Plotly.newPlot('graph', graphLines, self.graphLayout, this.graphConfig);
			self.resizeGraph()

			document.getElementById('graph').on('plotly_relayout', function(eventdata){
				if('relayedout' in eventdata){
					return;
				}
				
				let obj = {}
				if("xaxis.range[0]" in eventdata){
					obj["selectedx0"] = eventdata["xaxis.range[0]"]
				}if("xaxis.range[1]" in eventdata){
					obj["selectedx1"] = eventdata["xaxis.range[1]"]
				}if("xaxis.autorange" in eventdata){
					obj["selectedx0"] = null
					obj["selectedx1"] = null
				}
				if("selectedx0" in obj || "selectedx1" in obj){
					self.state.refilter(obj)
				}
				self.resizeGraph()

			});
		}).catch(e => console.log(e.message));
	}

	handleGraphRangeReset = () => {
		Plotly.relayout(document.getElementById('graph'), {"xaxis.autorange": true})//will cause relayout to run
	}

	render(){
		return (
			<div style={{height: this.graphLayout.height+"px", position: "relative"}}>
				{this.state.graphIsLoading && 
					(<div id="loading" className="p-4" style={{position: "absolute", width: "100%", zIndex: "20", background: "grey", opacity: "0.2", height: this.graphLayout.height+"px"}}>
						<div className="dotwrapper" style={{opacity: "1"}}>
							<div className="dot0" />
							<div className="dot1" />
							<div className="dot2" />
						</div>
					</div>)
				}
				{(this.state.start || this.state.end) && <button className="btn btn-secondary ml-3 mb-1" onClick={this.handleGraphRangeReset}>Jump to full-day</button>}
				<div id="graph"></div>
			</div>
		)
	}
}
export default AnalyticsGraph;